import type { WebhookEventName } from '@/modules/communications/types/webhook.types';

export type EmailTemplateDefinition = {
  subject: string;
  text: string;
};

const TEMPLATES: Partial<Record<WebhookEventName, EmailTemplateDefinition>> = {
  'reservation.created': {
    subject: 'Reserva creada: {{title}}',
    text: 'Reserva «{{title}}» ({{startDate}} → {{endDate}}).',
  },
  'reservation.cancelled': {
    subject: 'Reserva cancelada: {{title}}',
    text: 'Reserva «{{title}}» cancelada.',
  },
  'invoice.created': {
    subject: 'Factura {{invoiceId}}',
    text: 'Factura {{total}} {{currency}} ({{status}}).',
  },
  'logistics.scheduled': {
    subject: 'Logística {{orderId}}',
    text: 'Programada {{scheduledDate}} ({{type}}).',
  },
};

export function getEmailTemplate(
  event: WebhookEventName,
): EmailTemplateDefinition | null {
  return TEMPLATES[event] ?? null;
}
